// Keep the selected course and attribution when the checkout changes steps.
export function bookingStepSearch(search, step, courseCode) {
  const params = new URLSearchParams(search);
  params.set("step", String(step));
  if (!params.get("pcode") && courseCode) params.set("pcode", courseCode);
  return `?${params.toString()}`;
}

export function bookingCourseHref(search, courseCode) {
  const params = new URLSearchParams(search);
  params.delete("step");
  const code = courseCode || params.get("pcode") || "DOM-PAK-REA";
  if (!params.get("pcode")) params.set("pcode", code);
  return `/course/${encodeURIComponent(code)}?${params.toString()}`;
}
